import { getApp } from 'firebase/app';
import { getDoc, getFirestore, doc } from 'firebase/firestore';
import log from 'loglevel';
import { NODE_ENV } from '../constants';
import { FirebaseModule } from '../firebase';
import { Site } from './siteTypes';

const siteDev: Site = {
  id: '12345678901234567890',
  name: 'Localhost',
  origin: 'http://localhost:3000',
  useAppAccount: true,
};

/**
 * Fetch site by ID.
 * @param id ID.
 */
export const fetchSite = async (id: string): Promise<Site | undefined> => {
  // Do not rely on Firebase for localdev.
  if (NODE_ENV === 'development') {
    return siteDev;
  }

  if (!FirebaseModule.isReady()) {
    throw new Error('Firebase is not available');
  }

  // Retrieve document.
  const app = getApp();
  const db = getFirestore(app);
  const docSnap = await getDoc(doc(db, 'fitroom-widget-sites', id));

  if (!docSnap.exists()) {
    log.error(`Site does not exist with ID ${id}`);
    return undefined;
  }

  const docData = docSnap.data();
  const site: Site = {
    id,
    name: docData.name,
    origin: docData.origin,
    useAppAccount: docData.useAppAccount,
  };

  return site;
};
